<ng-template #spiffEditor let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-title">
            <span>SPIFF Editor</span>
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"> <i class="fa fa-close"></i> </button>
    </div>
    <div class="modal-body">
        <mat-tab-group [(selectedIndex)]="editorindex" (selectedIndexChange)="editorindex = $event">
            <mat-tab label="Setup">
                <div class="nav-item row m-0 p-2 w-100 justify-content-around ">

                    <mat-form-field appearance="outline" >
                        <mat-label>Spiff Name</mat-label>
                        <input matInput [formControl]="spiffname"/>
                    </mat-form-field>

                    <mat-form-field appearance="outline" >
                        <mat-label>Spiff Type</mat-label>
                        <mat-select [formControl]="spifftype" (selectionChange)="filterReport($event.value)">
                            <mat-option *ngFor="let loc of spifftypes" [value]="loc.value">
                                {{ loc.view }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    

                    <mat-form-field appearance="outline" >
                        <mat-label>Exluded Debtor Types</mat-label>
                        <mat-select [formControl]="excludedDt" (selectionChange)="filterReport($event.value)" multiple>
                            <mat-option *ngFor="let loc of dtypes" [value]="loc.typeid">
                                {{ loc.typename }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>


                    <mat-form-field appearance="outline">
                        <mat-label>Excluded Locations</mat-label>
                        <mat-select [formControl]="excludedLoc" (selectionChange)="filterReport($event.value)" multiple>
                            <mat-option *ngFor="let loc of locations" [value]="loc.loccode">
                                {{ loc.locationname }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>


                    <mat-form-field appearance="outline">
                        <mat-label>Report Default Dates</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate [formControl]="fromdateCtrlSetup" placeholder="Start date" (dateChange)="updateRange(true,true)">
                            <input matEndDate [formControl]="todateCtrlSetup" placeholder="End date" (dateChange)="updateRange(false,true)">
                        </mat-date-range-input>
                        <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                   

              
                </div>
                <hr class="w-100 m-0 p-0">
                <div class="row m-0 p-0 pb-3 pt-3 w-100 justify-content-between">
                    <button mat-stroked-button (click)="addingitems=!addingitems"><mat-icon>edit</mat-icon> Tracked Items ({{spiffitems.length}})</button>
                    <button mat-stroked-button class="text-danger" (click)="spiffitems = []; currentitems = []" *ngIf="spiffitems.length">Reset Items<mat-icon>delete</mat-icon> </button>                        
                </div>
                
                <div class="row m-0 p-0 w-100 justify-content-center">
                    <app-item-picker [selectionReverse]="true" [currentItems]="currentitems" *ngIf="addingitems || !spiffitems.length" (saveresults)="itemsSelected($event)"></app-item-picker>
                </div>
                
                <div *ngIf="!addingitems && spiffitems.length" class="w-100 m-0 p-0 spiff-item-table">
                    <table class="table table-bordered table-hover table-striped table-fixed w-100 m-0 p-0 spiff-item-table table-sticky">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Stockid</th>
                                <th>Desc.</th>
                                <th class="text-center">Discontinued?</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of spiffitems; let i = index">
                                <td (click)="removeitem(i)" class="removei text-center"><mat-icon>delete</mat-icon></td>
                                <td>{{item.stockid}}</td>
                                <td>{{item.description}}</td>
                                <td class="text-center">{{item.discontinued == 0 ? 'No' : 'Yes'}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
               

                <ng-container *ngIf="spiffitems.length">
                    <hr class="w-100 pb-2 p-0 m-0"/>
                    <div class="row m-0 p-2 w-100 justify-content-around">
                        <div class="col-auto">
                            <!-- <h4>Save config as</h4> -->
                        </div>
                        <div class="col-3 row m-0 p-0 justify-content-around">
                            <button mat-stroked-button color="primary" (click)="save()" [disabled]="!spifftype.value || !spiffname.value || !nameValid" *ngIf="!editingconfig">Save Config</button>
                            <button mat-stroked-button color="primary" (click)="update()" [disabled]="!spifftype.value || !spiffname.value || (!nameValid && spiffname.value != editingconfig.name)" *ngIf="editingconfig">Update Config</button>
                            <button mat-stroked-button color="primary" (click)="cancel()"  *ngIf="editingconfig">Cancel</button>
                        </div>
                        <div class="col-auto m-0 p-0">
                        </div>
                    </div>

                    <div class="row w-100 m-0 p-0" *ngIf="!spifftype.value || !spiffname.value || (!editingconfig && !nameValid) || (!nameValid && spiffname.value != editingconfig?.name)">
                        <mat-label class="text-danger">
                            SPIFF form invalid
                            <ng-container *ngIf="!nameValid && spiffname.value.length"> - {{spiffname.value}} title is currently in use.</ng-container>
                        </mat-label>
                    </div>
                </ng-container>

            </mat-tab>

            <mat-tab label="Active / Historic"> 
                <div *ngIf="allspiffs.length" class="w-100 m-0 p-0 spiff-item-table">
                    <table class="table table-bordered table-striped table-fixed w-100 m-0 p-0 spiff-item-table table-sticky">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Type</th>
                                <th>Name</th>
                                <th>From</th>
                                <th class="text-center">To</th>
                                <th># Items</th>
                                <th class="text-center">Active?</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let config of allspiffs; let i = index">
                                <td (click)="editSpiff(config)" class="removei text-center"><mat-icon>edit</mat-icon></td>
                                <td>{{config.type == '0' ? 'Store' : 'Salesman' }}</td>
                                <td>{{config.name}}</td>
                                <td>{{config.fromdate}}</td>
                                <td>{{config.todate}}</td>
                                <td>{{config.items.length}}</td>
                                <td class="text-center">
                                    <span [ngClass]="{'active': config.active == '1'}">{{config.active == '1' ? 'Yes': ''}}</span>
                                    <button *ngIf="config.active == '0'" mat-stroked-button (click)="setActive(config)">Set Active</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </mat-tab>
        </mat-tab-group>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="sendPrint()" *ngIf="rechtml && thistran">
            <mat-icon>print</mat-icon> Print
        </button>
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('cancel')">
            Close
        </button>
    </div>
</ng-template>






<div class="main-content">
    
    <div class="card">
        <div class="card-body">

            <div class="row m-100 p-0 m-0 justify-content-between">
                <ng-container *ngIf="adminuser">
                    <div class="m-0 p-0">
                        <button mat-mini-fab (click)="openEditor()"><mat-icon>settings</mat-icon></button>
                    </div>
                </ng-container>

                <div class="row m-0 p-0 col-8">
                    <!-- <div class="nav-item ml-1">
                        <form class="form-inline my-2 my-lg-0">
                            <mat-form-field appearance="outline">
                                <mat-label>Transaction Dates</mat-label>
                                <mat-date-range-input [rangePicker]="picker">
                                    <input matStartDate [formControl]="fromdateCtrl" placeholder="Start date" (dateChange)="updateRange(true,false)">
                                    <input matEndDate [formControl]="todateCtrl" placeholder="End date" (dateChange)="updateRange(false,false)">
                                </mat-date-range-input>
                                <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-date-range-picker #picker></mat-date-range-picker>
                            </mat-form-field>
                        </form>
                    </div> -->
    
                    <mat-form-field appearance="outline" class="mr-1">
                        <mat-label>Location</mat-label>
                        <mat-select [formControl]="defaultlocation" (selectionChange)="filter()" multiple appSelectAll>
                            <mat-option *ngFor="let loc of locations" [value]="loc.loccode">
                                {{ loc.locationname }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
    
                    <mat-form-field appearance="outline" class="ml-1">
                        <mat-label>Salespeople</mat-label>
                        <mat-select [formControl]="salespersonRef" (selectionChange)="filter()" multiple appSelectAll>
                            <mat-option *ngFor="let sp of salespeople" [value]="sp.salesmancode">
                                {{ sp.salesmanname }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
    

                </div>

                <mat-form-field appearance="outline">
                    <mat-label>Order Search</mat-label>
                    <input matInput [formControl]="searchInput" (input)="filter()"
                        placeholder="Search..." class="text-right" appCollapseKeyboard />
                    <span matSuffix>
                        <button mat-icon-button (click)="filter()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </span>
                    <span matSuffix>
                        <button mat-icon-button (click)="runSpiff()">
                            <mat-icon>refresh</mat-icon>
                        </button>
                    </span>
                </mat-form-field>
                
                <div class="row">
                    <button mat-raised-button (click)="export('pdf')" [disabled]="!reportfiltered.length" class="bg-danger text-white export-btn">PDF</button>
                    <button mat-raised-button (click)="export('xls')" [disabled]="!reportfiltered.length" class="bg-success text-white export-btn">XLSX</button>
                </div>
            </div>
            
            <mat-tab-group [(selectedIndex)]="currentindex" (selectedIndexChange)="tabchange($event)">
                <mat-tab class="w-50">
                    <ng-template mat-tab-label>
                    Salesman 
                    <ng-container *ngIf="salesmanspiff?.name">({{salesmanspiff.name}})</ng-container>
                    <ng-container *ngIf="spiffrunning">
                        &nbsp;
                        <svg class='spinner' width='20px' height='20px' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'> <circle class='path' fill='none' stroke-width='6' stroke-linecap='round' cx='33' cy='33' r='30'></circle> </svg>
                    </ng-container>
                </ng-template>
                    <table class="table table-bordered table-hover table-striped w-100 m-0 p-0" *ngIf="salesmanspiff">
                        <thead>
                            <tr>
                                <th>Location</th>
                                <th>Salesman</th>
                                <th>Supplier</th>
                                <th>Stock ID</th>
                                <th>Description</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Total</th>
                                
                            </tr>
                        </thead>
                        <tbody *ngIf="reportfiltered.length && salesman">
                            <tr *ngFor="let o of dataObs | async">
                                <td>{{o.loccode}}</td>
                                <td>{{o.salesmanname}}</td>
                                <td>{{o.supplier}}</td>
                                <td>{{o.stockid}}</td>
                                <td>{{o.description}}</td>
                                <td class="text-center">{{o.qty}}</td>
                                <td class="text-right">{{o.Price | currency}}</td>
                                <td class="text-right">{{o.totalSales | currency}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="!salesmanspiff?.items?.length && salesman">
                            <td colspan="8" class="text-center">
                                <h4>No results</h4>
                            </td>
                        </tbody>
                        <tr *ngIf="reportfiltered.length && salesman">
                            <td class="text-left">Lines: {{reportfiltered.length}} / {{currentreport.items.length}}</td>
                            <td colspan="4">{{totals(reportfiltered)}}</td>
                            <td class="text-left">Units: {{totalinfo.units}}</td>
                            <td class="text-right">Avg: {{totalinfo.avg | currency}}</td>
                            <td class="text-right">Total: {{totalinfo.tot | currency}}</td>
                        </tr>
                    </table>
                </mat-tab>
                <mat-tab class="w-50">
                    <ng-template mat-tab-label>
                        Store 
                        <ng-container *ngIf="storespiff?.name">({{storespiff.name}})</ng-container>
                        <ng-container *ngIf="spiffrunning">
                            &nbsp;
                            <svg class='spinner' width='20px' height='20px' viewBox='0 0 66 66' xmlns='http://www.w3.org/2000/svg'> <circle class='path' fill='none' stroke-width='6' stroke-linecap='round' cx='33' cy='33' r='30'></circle> </svg>
                        </ng-container>
                      </ng-template>
                    <table class="table table-bordered table-hover table-striped w-100 m-0 p-0" *ngIf="reportfiltered">
                        <thead>
                            <tr>
                                <th>Location</th>
                                <th>Stock ID</th>
                                <th>Supplier</th>
                                <th>Description</th>
                                <th>Quantity</th>
                                <th>Price</th>
                                <th>Total</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="reportfiltered.length && store">
                            <tr *ngFor="let o of dataObs | async">
                                <td>{{o.loccode}}</td>
                                <td>{{o.stockid}}</td>
                                <td>{{o.supplier}}</td>
                                <td>{{o.description}}</td>
                                <td class="text-center">{{o.qty}}</td>
                                <td class="text-right">{{o.Price | currency}}</td>
                                <td class="text-right">{{o.totalSales | currency}}</td>
                            </tr>
                        </tbody>
                        <tbody *ngIf="!storespiff?.items?.length && store">
                            <td colspan="7" class="text-center">
                                <h4>No results</h4>
                            </td>
                        </tbody>
                        <tr *ngIf="reportfiltered.length && store">
                            <td class="text-left">Lines: {{reportfiltered.length}} / {{currentreport.items.length}}</td>
                            <td colspan="3">{{totals(reportfiltered)}}</td>
                            <td class="text-left">Units: {{totalinfo.units}}</td>
                            <td class="text-right">Avg: {{totalinfo.avg | currency}}</td>
                            <td class="text-right">Total: {{totalinfo.tot | currency}}</td>
                        </tr>
                    </table>
                </mat-tab>
            </mat-tab-group>
            <mat-paginator [ngClass]="{'d-none': !reportfiltered.length}" [pageSizeOptions]="items_per_page" [pageSize]="pagesizedefault" showFirstLastButtons></mat-paginator>
        </div>
    </div>

</div>
